<template>
    <div id="HomeContentLInkItems">
        <div class="itemsTitle">{{title}}</div>
        <div class="itemscontent">
            <div class="content-flexItem" v-for="(aItem, index) in dataArray">
                <HomeLinkItem :item="aItem"></HomeLinkItem>
            </div>
        </div>
    </div>
</template>

<script>
    import HomeLinkItem from './HomeLinkItem'
    export default {
        name: "HomeContentLInkItems",

        components: {
            HomeLinkItem
        },
        props: ['title', 'dataArray'],
        data() {
            return {

            }
        },
        destroyed() {
        },
        created() {
        },
        methods: {}
    }
</script>

<style lang="less" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #HomeContentLInkItems {
        padding: 0;
        background-color: #fff;
    }

    .itemsTitle {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #eee;
        text-align: left;
        font-weight: 700;
        font-style: normal;
        font-size: 22px;
        color: rgba(0, 0, 0, 0.847058823529412);
        line-height: 18px;
        padding-left: 20px;
    }

    .itemscontent {
        width: 100%;
        display: flex;
        justify-content: left;
        flex-direction: row;
        flex-wrap: wrap;
        .content-flexItem{
            margin-top: 10px;
            margin-left: 20px;
            background-color: red;
            padding: 10px;
        }
    }

</style>
